import { Partner, PartnerData, PartnerCode, PartnerMap, Product, ProductCode } from './models';
import { partners, products } from './data';
import { getCookie, setCookie, unsetCookie } from '../utils';

export const getProductCodeCookieName = () => `${getPartnerCode()}_product_code`;

export const getPartnerCode = () =>
  Object.keys(partners).find(
    (partnerCode) => partners[partnerCode].reactAppPartner === globals.REACT_APP_PARTNER
  ) as PartnerCode;

function partnerValue<T>(values: PartnerMap<T>): T;
function partnerValue<T>(values: Partial<PartnerMap<T>>): T | undefined;
function partnerValue<T>(values: Partial<PartnerMap<T>>, defaultValue: T): T;
function partnerValue<T>(values: Partial<PartnerMap<T>>, defaultValue?: T): T | undefined {
  const partnerCode = getPartnerCode();
  return values.hasOwnProperty(partnerCode) ? values[partnerCode] : defaultValue;
}

const getCurrentProductCode = (): ProductCode => {
  const { availableProductCodes, defaultProductCode } = getPartner();
  const currentCode = getCookie(getProductCodeCookieName());

  if (availableProductCodes && currentCode && availableProductCodes.includes(currentCode as ProductCode)) {
    return currentCode as ProductCode;
  }

  return defaultProductCode;
};

const partnerPrototype = {
  setProduct(newProductCode: ProductCode | undefined) {
    if (newProductCode) {
      console.log(`set product code: ${newProductCode}`);
      const { availableProductCodes } = getPartner();
      if (availableProductCodes && availableProductCodes.includes(newProductCode)) {
        setCookie(getProductCodeCookieName(), newProductCode, { expires: 7 });
      }
    } else {
      unsetCookie(getProductCodeCookieName());
    }
  },

  get product(): Product {
    return products[getCurrentProductCode()];
  },

  get productCode(): ProductCode {
    return this.product.productCode;
  },

  get chatConfig() {
    return this.product.chatConfig;
  },

  get claimUrl() {
    return this.product.claimUrl;
  },

  get productName() {
    return this.product.productName;
  },
};

export const getPartner = (): Partner => {
  return Object.assign<typeof partnerPrototype, PartnerData>(
    Object.create(partnerPrototype),
    partners[getPartnerCode()]
  );
};

export { partnerValue };



// WEBPACK FOOTER //
// ./packages/smart-home-support/partner/utils.ts